import { render, staticRenderFns } from "./payment-account.vue?vue&type=template&id=b4476b0a&"
import script from "./payment-account.vue?vue&type=script&lang=js&"
export * from "./payment-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports